import React, { useEffect, useState } from 'react'
import './style.css'
import { Link } from 'react-router-dom'
import axios from 'axios'
import { useToast } from '@chakra-ui/react'


const SITE_KEY = '6LfvHEArAAAAAEKbWYh54PMdI4zzWEgSsP4p3-g9'

const HomePage = () => {
    const BASE_URL = process.env.REACT_APP_DEPLOYED_BASE_URL;
    const toast = useToast();
    const [captchaScore, setCaptchaScore] = useState(null)
    const [formValue, setFormValue] = useState({
        fullName: '',
        email: '',
        phoneNumber: '',
        youtubeLink: '',
        instagramLink: '',
        tiktokLink: ''
    })
    const [formStarted, setFormStarted] = useState(false);
    const [formSubmitted, setFormSubmitted] = useState(false);

    const handleChange = (e) => {
        if (!formStarted) {
            setFormStarted(true);
            setFormSubmitted(false); // reset if someone starts again
            window.gtag && window.gtag('event', 'form_start_request_access', {
                event_category: 'engagement',
                event_label: 'request_access_form',
                
            });     
        }

        setFormValue({
            ...formValue,
            [e.target.name]: e.target.value
        })
    }
  

    useEffect(() => {
        const handleBeforeUnload = () => {
            if (formStarted && !formSubmitted) {
                      
                window.gtag && window.gtag('event', 'form_abandon_request_access', {
                    event_category: 'engagement',
                    event_label: 'request_access_form',
                });
            }
        };

        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => window.removeEventListener('beforeunload', handleBeforeUnload);
    }, [formStarted, formSubmitted]);

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (!window.grecaptcha) {
            toast({
                title: "reCAPTCHA not loaded",
                description: "Please refresh and try again.",
                status: "error",
                position: "bottom",
                duration: 3000,
            });
            return;
        }
        try {
            const token = await window.grecaptcha.execute(SITE_KEY, { action: "form_submit" });
            const payload = {
                ...formValue,
                token
            };
            const result = await axios.post(`${BASE_URL}/cm-hub-request/`, payload);
            window.gtag && window.gtag('event', 'form_submit_request_access', {
                event_category: 'engagement',
                event_label: 'request_access_form',
            });
            setFormSubmitted(true); // mark form as submitted


            toast({
                title: "Request sent successfully",
                description: `${result.data.message}`,
                status: "success",
                position: "bottom",
                duration: 3000,
            });


        } catch (error) {
            toast({
                title: "Failed to send request",
                description: `${error.message}`,
                status: "error",
                position: "bottom",
                duration: 3000,
            });
        }
    }

    useEffect(() => {
        const script = document.createElement("script");
        script.src = `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`;
        script.async = true;
        script.defer = true;
        script.id = 'recaptcha-script';
        document.body.appendChild(script);

        return () => {
            const scriptTag = document.getElementById('recaptcha-script');
            if (scriptTag) {
                document.body.removeChild(scriptTag);
            }
            const badge = document.querySelector('.grecaptcha-badge');
            if (badge) {
                badge.parentNode.removeChild(badge);
            }

            if (window.grecaptcha) {
                delete window.grecaptcha;
            }
        };
    }, []);

    return (
        <>
            <header className="header">
                <div className="container">
                    <div className="logo"><a href="#"><img src={`/cm_logo.png`} alt="Logo" /></a></div>
                    <Link to='/login' className="login-btn">Login</Link>
                </div>
            </header>

            <section className="hero">
                <div className="container">

                    <div className="hero-text">
                        <p>UNLOCK THE POWER OF</p>
                        <h1>SASHA</h1>
                    </div>

                    {/* <div className="hero-text">
                    </div> */}

                    <div className="hero-img">
                        <img src={`/mackbook_home.png`} alt="Laptop CRM View" />
                    </div>
                </div>
            </section>

            <section className="cta-banner">
                <div className="container">
                    <h2>LEVEL UP YOUR CONTENT CREATOR BUSINESS</h2>
                </div>
            </section>

            <section className="description">
                <div className="container">
                    <p>Introducing CM Hub—the all-in-one CRM developed by Creatives Matter, built specifically for content creators. This powerful platform puts you in control of your business, making it easy to track active campaigns, manage brand rep relationships, submit invoices, and stay organized every step of the way. With tools to launch targeted brand outreach, review contracts, and even pitch yourself directly to past brand partners, CM Hub streamlines the entire creator-brand workflow. It’s everything you need to stay on top of your collaborations and grow your brand, all in one place.</p>
                    <p><strong>Try All Premium Features Free for 30 Days</strong></p>
                    <p>Enjoy full access to our premium tools—completely free for your first 30 days. No pressure to upgrade when the trial ends. Plus, our <strong>Deals</strong> feature is always <strong>100% free</strong> to help you stay organized and track your campaigns with ease.</p>
                </div>
            </section>

            <section className="request-access">
                <div className="container">
                    <div className="overlay">
                        <h2>REQUEST ACCESS</h2>
                        <p>Enjoy All the Features for 30 Days Free</p>
                        <form onSubmit={handleSubmit}>
                            <div className="form_row">
                                <div className="form_outer"><input type="text" onChange={handleChange} name='fullName' value={formValue.fullName} placeholder="Full Name*" required /></div>
                                <div className="form_outer"><input type="email" onChange={handleChange} name='email' value={formValue.email} placeholder="Email*" required /></div>
                            </div>
                            <div className="form_row">
                                <div className="form_outer"> <input type="number" onChange={handleChange} name='phoneNumber' value={formValue.phoneNumber} placeholder="Phone Number" /></div>
                                <div className="form_outer"> <input type="url" onChange={handleChange} name='youtubeLink' value={formValue.youtubeLink} placeholder="YouTube Link" /></div>
                            </div>
                            <div className="form_row">
                                <div className="form_outer"> <input type="url" onChange={handleChange} name='instagramLink' value={formValue.instagramLink} placeholder="Instagram Link" /></div>
                                <div className="form_outer"> <input type="url" onChange={handleChange} name='tiktokLink' value={formValue.tiktokLink} placeholder="TikTok Link" /></div>
                            </div>
                            <div className="form_btn"> <button type="submit">SEND</button></div>
                        </form>
                    </div>
                </div>
            </section>

            <footer className="footer">
                <div className="container">
                    <p>© 2025 Creatives Matter LLC</p>
                    <div className="footer-links">
                        <Link to='/privacy-policy'>Privacy Policy</Link>
                        <Link to='/terms-of-service'>Terms of Service</Link>
                    </div>
                </div>
            </footer>
        </>
    )
}

export default HomePage